module.exports = __webpack_public_path__ + "static/media/logo-external-retina.7fd7bcbb.png";